module.exports = __webpack_public_path__ + "static/media/banner_creative.e19df9ca.png";